/**
 * @flow
 * @relayHash 1d3a66af8507f094af2123a831d83db9
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ValidateCSVImportInput = {|
  csvImportId: string,
  columnMapping: any,
|};
export type ValidateCSVImportMutationVariables = {|
  input: ValidateCSVImportInput
|};
export type ValidateCSVImportMutationResponse = {|
  +validateCSVImport: {|
    +validationResult: {|
      +valid: boolean,
      +errors: ?any,
      +totalErrors: number,
      +newCount: ?number,
      +updateCount: ?number,
    |}
  |}
|};
export type ValidateCSVImportMutation = {|
  variables: ValidateCSVImportMutationVariables,
  response: ValidateCSVImportMutationResponse,
|};
*/


/*
mutation ValidateCSVImportMutation(
  $input: ValidateCSVImportInput!
) {
  validateCSVImport(input: $input) {
    validationResult {
      valid
      errors
      totalErrors
      newCount
      updateCount
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "ValidateCSVImportInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "validateCSVImport",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ValidateCSVImportPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "validationResult",
        "storageKey": null,
        "args": null,
        "concreteType": "CSVValidationResult",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "valid",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "errors",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "totalErrors",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "newCount",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "updateCount",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ValidateCSVImportMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "ValidateCSVImportMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "ValidateCSVImportMutation",
    "id": null,
    "text": "mutation ValidateCSVImportMutation(\n  $input: ValidateCSVImportInput!\n) {\n  validateCSVImport(input: $input) {\n    validationResult {\n      valid\n      errors\n      totalErrors\n      newCount\n      updateCount\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '9de6cb9b3a6c0dad329c2a933bb33f32';
module.exports = node;
